module.exports = __webpack_public_path__ + "static/staff_of_the_woodlands-28d086de81cc2d15ca0e0d1fac1c3fe4.jpeg";